module.exports = __webpack_public_path__ + "img/footer_profile--disabled.21ec2275.svg";